import type { PropsWithChildren } from 'react';
import cn from '@/utils/merge-class-names';

type Props = {
  disabled?: boolean; // NOTE: show field but disabled
  isSelectable?: boolean; // NOTE: do not show field
  isSelected?: boolean;
  onSelected: (value: boolean) => void;
  checkboxPosition?: 'left' | 'right';
  className?: string;
};

export default function SelectableListItem({
  className,
  checkboxPosition = 'left',
  disabled = false,
  isSelectable = false,
  isSelected = false,
  onSelected,
  children,
}: PropsWithChildren<Props>) {
  if (!isSelectable) return children;

  return (
    <div
      className={cn('flex flex-1 cursor-pointer items-center gap-2', className)}
      onClick={() => !disabled && onSelected(!isSelected)}>
      {checkboxPosition === 'left' && (
        <input
          type='checkbox'
          disabled={disabled}
          checked={isSelected}
          readOnly
          className='checkbox-primary checkbox rounded-full border-base-200'
        />
      )}

      <div className='flex-1 pointer-events-none'>{children}</div>
      {checkboxPosition === 'right' && (
        <input
          type='checkbox'
          disabled={disabled}
          checked={isSelected}
          readOnly
          className='checkbox-primary checkbox rounded-full border-base-200'
        />
      )}
    </div>
  );
}
